import { render, staticRenderFns } from "./SelectAddons.vue?vue&type=template&id=24c2f17a&scoped=true"
import script from "./SelectAddons.vue?vue&type=script&lang=js"
export * from "./SelectAddons.vue?vue&type=script&lang=js"
import style0 from "./SelectAddons.vue?vue&type=style&index=0&id=24c2f17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2f17a",
  null
  
)

export default component.exports